/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../actionTypes/homeActionTypes";

export const mutationAgentSignUpAction = {
  STARTED: (payload: any, logincallback: (response: any) => void) => ({
    type: types.MUTATION_AGENT_SIGNUP.STARTED,
    payload: payload,
    logincallback,
  }),
  FULLFILLED: (results: any) => ({
    type: types.MUTATION_AGENT_SIGNUP.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.MUTATION_AGENT_SIGNUP.REJECTED }),
};

export const addNewsLetterMailingListAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_NEWSLETTER_MAILING_LIST.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_NEWSLETTER_MAILING_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.ADD_NEWSLETTER_MAILING_LIST.REJECTED }),
};


export const addContactUsInfoAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_CONTACT_US_INFO_LIST.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_CONTACT_US_INFO_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.ADD_CONTACT_US_INFO_LIST.REJECTED }),
};
